export default class UIError extends Error {
  data

  constructor(message, data) {
    super(message);

    this.data = data;
  }
}
